import { getRecordingAudio } from "@/services/getRecordingAudio";
import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { useEffect } from "react";

const useGetRecordingAudio = (recordingId: string, enabled = true, onError?: (error: AxiosError) => void) => {
  const { data, isLoading, refetch, isError, error, ...rest } = useQuery({
    queryKey: ["recording-audio", recordingId],
    queryFn: () => getRecordingAudio(recordingId),
    enabled: enabled && !!recordingId,
  });

  useEffect(() => {
    if (isError) onError?.(error as AxiosError);
  }, [isError, error, onError]);

  return {
    data,
    isLoadingRecordingAudio: isLoading,
    refetchRecordingAudio: refetch,
    isError,
    error,
    ...rest,
  };
};

export default useGetRecordingAudio;
